import Config from '@root/wrapperConfig';

export function isNewCart() {
  return Config.server.api.indexOf('api.delikateska.ru') === -1;
}
